import { render, staticRenderFns } from "./UserSupport.vue?vue&type=template&id=54b12d1c&scoped=true&"
import script from "./UserSupport.vue?vue&type=script&lang=js&"
export * from "./UserSupport.vue?vue&type=script&lang=js&"
import style0 from "./UserSupport.vue?vue&type=style&index=0&id=54b12d1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b12d1c",
  null
  
)

export default component.exports